/* Knopftruhe Custom JS */
/* Eigene Anpassungen nur hier eintragen */
(function () {
  function getMinQtyMap() {
    const el = document.querySelector('[data-knopftruhe-minqty-map]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return {};
    }
  }

  function getQtyInput() {
    return document.querySelector('.product__quantity');
  }

  function getVariantId(event) {
    if (event && event.detail && event.detail.variant && event.detail.variant.id) {
      return String(event.detail.variant.id);
    }

    const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"]');
    return idInput ? String(idInput.value) : null;
  }

  function getOrCreateHintEl(qtyInput) {
    const holder = qtyInput.closest('product-quantity') || qtyInput.parentElement;
    if (!holder || !holder.parentElement) return null;

    let hint = holder.parentElement.querySelector('[data-knopftruhe-minqty-hint]');
    if (!hint) {
      hint = document.createElement('p');
      hint.setAttribute('data-knopftruhe-minqty-hint', '');
      hint.className = 'knopftruhe-minqty-hint';
      holder.insertAdjacentElement('afterend', hint);
    }
    return hint;
  }

  function updateHint(qtyInput, minQty, masse) {
    const hint = getOrCreateHintEl(qtyInput);
    if (!hint) return;

    if (minQty > 1) {
      hint.textContent = masse
        ? `Mindestmenge ${minQty} Stück bei Miniknöpfen (${masse})`
        : `Mindestmenge ${minQty} Stück bei Miniknöpfen`;
      hint.style.display = '';
    } else {
      hint.textContent = '';
      hint.style.display = 'none';
    }
  }

  function applyMinQty(variantId) {
    const qtyInput = getQtyInput();
    const map = getMinQtyMap();

    if (!qtyInput || !variantId) return;

    const entry = map[variantId] || {};
    const minQty = parseInt(entry.minQty || 1, 10);
    const masse = entry.masse || '';

    qtyInput.min = minQty;
    qtyInput.value = minQty;
    qtyInput.step = 1;
    qtyInput.dataset.minQty = minQty;

    updateHint(qtyInput, minQty, masse);
  }

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
      applyMinQty(getVariantId());
    }, 100);
  });

  document.addEventListener('variant:change', function (event) {
    setTimeout(function () {
      applyMinQty(getVariantId(event));
    }, 100);
  });

  document.addEventListener('variant:changed', function (event) {
    setTimeout(function () {
      applyMinQty(getVariantId(event));
    }, 100);
  });

  document.addEventListener('change', function () {
    setTimeout(function () {
      applyMinQty(getVariantId());
    }, 150);
  });
})();